import { html } from "@microsoft/fast-element";
import { startTemplate } from "@microsoft/fast-foundation";
export const FeedNavigationItemTemplate = html `
    <a
        class="control"
        download="${x => x.download}"
        href="${x => x.href}"
        hreflang="${x => x.hreflang}"
        ping="${x => x.ping}"
        referrerpolicy="${x => x.referrerpolicy}"
        rel="${x => x.rel}"
        target="${x => x.target}"
        type="${x => x.type}"
        aria-current="${x => (x.active ? "page" : "false")}"
        tabindex="0"
        role=${x => (x.href ? undefined : "link")}
    >
        ${startTemplate}
        <span class="content" part="content">
            <slot></slot>
        </span>
    </a>
`;
